export const RebuildLogo = ({ scale = 1, interactive = true }) => {
  const brickH = 28 * scale;
  const gap = 4 * scale;
  const buildGap = 4 * scale;
  const fontSize = 14 * scale;
  const hyphenSize = 18 * scale;

  const getWidth = (label) => {
    if (label.length === 1) return 32 * scale;
    if (label === 'RE' || label === 'ME') return 40 * scale;
    return 58 * scale;
  };

  const getPaddingX = (label) => {
    if (label.length === 1) return 8 * scale;
    if (label === 'RE' || label === 'ME') return 8 * scale;
    return 12 * scale;
  };

  const Brick = ({ label, colorVar }) => (
    <div
      style={{
        minWidth: getWidth(label),
        padding: `0 ${getPaddingX(label)}px`,
        height: brickH,
        borderRadius: 4 * scale,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: `var(${colorVar})`,
      }}
    >
      <span className="header-logo-text" style={{ fontSize, fontWeight: 700, fontFamily: 'var(--font-heading)' }}>
        {label}
      </span>
    </div>
  );

  const logoContent = (
    <div className="inline-flex items-center" style={{ gap }}>
      <Brick label="RE" colorVar="--theme-primary" />
      <span className="header-logo-hyphen" style={{ fontSize: hyphenSize, fontWeight: 700, lineHeight: 1, minWidth: 12 * scale, textAlign: 'center' }}>-</span>
      <div className="inline-flex items-center" style={{ gap: buildGap }}>
        <Brick label="B" colorVar="--theme-primary" />
        <Brick label="U" colorVar="--theme-primary" />
        <Brick label="I" colorVar="--theme-primary" />
        <Brick label="L" colorVar="--theme-primary" />
        <Brick label="D" colorVar="--theme-primary" />
      </div>
      <span className="header-logo-hyphen" style={{ fontSize: hyphenSize, fontWeight: 700, lineHeight: 1, minWidth: 12 * scale, textAlign: 'center' }}>-</span>
      <Brick label="ME" colorVar="--theme-primary" />
    </div>
  );

  if (!interactive) {
    return (
      <div className="inline-flex" data-testid="rebuild-logo-static" aria-hidden="true">
        {logoContent}
      </div>
    );
  }

  return (
    <button
      onClick={() => { window.location.href = '/'; }}
      className="inline-flex"
      data-testid="rebuild-logo"
      aria-label="RE-BUILD-ME home"
    >
      {logoContent}
    </button>
  );
};

export default RebuildLogo;
